module.exports = __webpack_public_path__ + "static/media/page_17.f29cb2aa.jpg";